var scope_0 = require('/Users/bharrison/dev/mysite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a2b4e0a9190827409181f607a19f1e0.js').default;
var scope_1 = require('/Users/bharrison/dev/mysite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3aee31dba59d09d072a2cc817fc9f3a7.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    